<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else>
    <!-- Keep-alive should wrap <router-view /> -->

    <div class="homepage d-flex flex-column vh-100">
      <!-- navbar -->
      <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
        <div class="d-flex align-items-center">

          <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

          <span>
            <h4 class="text-white">{{ language?.Room_View }}</h4>
          </span>


          <!-- <div class="d-flex align-items-center gap-2 ms-auto">
                
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#branch"
                  aria-controls="branch">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-plus  d-flex m-1 h4 text-white"></i>
                  </b>
                  </a>
               </div> -->
        </div>




      </div>

      <!-- body -->
      <div class="my-auto overflow-auto vh-100">

        <!-- Top Evets -->
        <div class="pt-3 bg_card">

          <div class="row">
            <div class="col-6 col-lg-3 mb-3" v-for="(item, i) in get_room_booking" :key="i">
            <router-link
                      :to="getBookingLink(item)"
                      class="text-decoration-none text-dark"
                    >
                  

                <div :class="item.today_bookid !== null?'card bg-light-red':'card '"  >

                  <div class="card-body">

                    <div class="col-12">
                      <div class="row">

                        <div class="col-4">

                          <h3>{{ item.roomno }}</h3>


                        </div>

                        <div class="col-8">


                          <span class="badge bg-success rounded-pill">
                            {{ item.roomtype }} / {{ item.catid }}
                          </span>



                        </div>





                        <strong>{{ language?.capacity }}: {{ item.capacity }}</strong>


                          <strong>{{ language?.status }}:
                            <span :class="item.status == 1 ? 'text-danger' : 'text-success'">
                              {{ item.status == 1 ? 'Booked' : 'Available' }}
                            </span>
                          </strong>



                        <p class="mb-0">

                        </p>

                      </div>
                    </div>

                  </div>




              <div class="card-footer" v-if="item.nextdate !== null" >                       
                   <span ><strong>Next Booking:</strong>{{ item.nextdate }}</span><br>
                
               


                 
          </div>




     








                </div>

              </router-link>

            </div>
          </div>

     



        </div>









      </div>

      <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="branch" aria-labelledby="branchLabel">
        <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
          <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i
              class="bi bi-arrow-left fs-5 text-white"></i></a>
          <h6 class="offcanvas-title text-white m-0" id="branchLabel">{{ language?.create_Room }}</h6>
        </div>
        <div class="offcanvas-body">


          <div class="mb-3">
            <label for="mobile" class="form-label">{{ language?.Room_No }}</label>
            <input type="text" id="mobile" v-model="room.roomno" class="form-control" required>
          </div>

          <div class="mb-3">
            <label for="mobile" class="form-label">{{ language?.Room_Type }}</label>
            <select id="roomtype" v-model="room.roomtype" class="form-control" required>
              <option value="">Select Room Type</option>
              <option value="AC">AC</option>
              <option value="NonAC">Non AC</option>
            </select>
          </div>

          <div class="mb-3">
            <label for="mobile" class="form-label">{{ language?.room_description }}</label>
            <input type="text" id="mobile" v-model="room.description" class="form-control" required>
          </div>

          <div class="mb-3">
            <label for="mobile" class="form-label">{{ language?.mrp }}</label>
            <input type="text" id="mobile" v-model="room.mrp" class="form-control" required>
          </div>

          <div class="mb-3">
            <label for="mobile" class="form-label">{{ language?.cost }}</label>
            <input type="text" id="mobile" v-model="room.cost" class="form-control" required>
          </div>

          <div class="mb-3">
            <label for="mobile" class="form-label">{{ language?.capacity }}</label>
            <input type="text" id="mobile" v-model="room.capacity" class="form-control" required>
          </div>


          <div class="mb-3">
            <label for="roomtype" class="form-label">{{ language?.Room_Category }}</label>
            <select id="roomtype" v-model="room.catid" class="form-control" required>
              <option value="">Select Room Category</option>
              <option v-for="item in roomcatlist" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>


          <div class="mb-3">
            <label for="mobile" class="form-label">{{ language?.status }}</label>
            <select id="roomtype" v-model="room.status" class="form-control" required>
              <option value="">Select Room Status</option>
              <option value="active">Active</option>
              <option value="deactive">De-Active</option>
            </select>
          </div>









          <div class="d-flex gap-2">
            <button class="btn btn-primary w-100 " @click="addBranch">Save</button>
            <button class="btn btn-secondary w-50" @click="goprevious">Back</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<style>
.bg_card {
  background: #ededec;
  margin: 10px 0px;
  padding-bottom: 28px;
  padding: 10px;
}
.bg-light-red {
  background-color: #ffd8db; /* Light red color */
}

</style>

<script>
import axios from "@/plugins/axios";

export default {
  name: 'Branch',
  components: {
  },
  mounted() {
    //  this.fetchWeather();
    this.getBranches(); // Call the method here

  },
  data() {
    return {
      loading: false,
      error: null,
      isUserLogged: false,
      user_details: [],


      language: this.getLocalStorageArray('lang'),
      room: {
        roomno: '',
        roomtype: '',
        description: '',
        mrp: '',
        cost: '',
        capacity: '',
        status: '',
        catid: ''

      },
      getallroom: [],
      roomcatlist: [],
      get_room_booking: [],
      branch_name: ''

    }
  },
  methods: {
    initializeHomeContent() {


    },
    goBack() {

      this.$router.go(-1);
    },
    goprevious() {

      this.$router.go("/branch");
    },



    async getBranches() {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        axios.post("getRoomlist").then((response) => {
          self.roomcatlist = response.data.roomcatlist;
          self.getallroom = response.data.getallroom;
          self.get_room_booking = response.data.get_room_booking;
          self.language = response.data.language;
          localStorage.setItem('lang', response.data.language);

        }).then(() => {
          self.initializeHomeContent();
        }).catch((err) => {

        });;


      } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },





    addBranch() {
      this.loading = true;
      this.error = null;

      try {
        var self = this;
        axios.post("addroom", self.room).then((response) => {

          self.getallroom = response.data.getallroom;
          self.language = response.data.language;
          self.$swal.fire(response.data.message);
          if (response.data.success) {
            self.branch = { name: '', address: '', contact: '', };
          }
          window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();




        }).then(() => {
          self.initializeHomeContent();
        }).catch((err) => {

        });;


      } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },


    editBranch(editBranch) {
      window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).show();
      this.room = editBranch;
    },





    deleteBranch(id = "") {
      this.loading = true;
      this.error = null;

      try {
        var self = this;

        this.$swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel",
        }).then((result) => {
          if (result.isConfirmed) {
            axios.post("delete_room", { id: id }).then((response) => {
              self.getallroom = response.data.getallroom;
              self.language = response.data.language;
              self.$swal.fire(response.data.message);

              if (response.data.success) {
                window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("branch")).hide();
              }
            }).then(() => {
              self.initializeHomeContent();
            }).catch((err) => {
              self.$swal.fire("Error!", "Something went wrong.", "error");
            });
          }
        });

      } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
      } finally {
        this.loading = false;
      }
    },

    getLocalStorageArray(key) {
      let data = localStorage?.getItem(key);
      try {
        return data ? JSON.parse(data) : [];
      } catch (e) {
        console.error("Error parsing localStorage data", e);
        return [];
      }
    },

    getBookingLink(item) {
      if (item.today_bookid !== null) {
          if( item.today_exactchecking !=='00:00:00')
            return `/roombookingdetails?q=${item.id}`
          else
            return `/roombooking?q=${item.id}&bookid=${item.today_bookid}`
      } else {
        return `/roombooking?q=${item.id}`
      }
    }



















  }
}






</script>
